const actionType = 'MESSAGE_USERS';

export default actionType;
